import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

function RequestTokenPaid() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);

  const [Uid, setUid] = useState(null);
  const [uplineId, setuplineId] = useState(null);
  const [fdate, setfdate] = useState("");
  const [tdate, settdate] = useState("");
  const [Rank, setRank] = useState(0);

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/PaidRewardHistory",
        {
          loginid: userId,
          uid: Uid || 0,
          uplineid: uplineId || 0,
          RankId: Rank,
          fdate: fdate,
          tdate: tdate,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      console.log("PaidRewardHistory", responceRight?.data);
      responceRight = responceRight.data.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          uid: item.uid,
          id: item?.id,
          userid: ` ${item.uid}`,
          address: item.wallet,
          row: `  ${item.row} `,
          amountusd: item.Req_matching,
          requestAmount: item.reward,
          widthralAmount: ` ${item.reward}`,
          date: ` ${item.date}`,
          tdate: ` ${item.tdate}`,
          remark: ` ${item.rank_name}`,
          txn: ` ${item.txn}`,
        });
        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
        "/PaidRewardHistory",
        {
          loginid: userId,
          uid: Uid || 0,
          uplineid: uplineId || 0,
          RankId: Rank,
          fdate: fdate,
          tdate: tdate,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      responceRight = responceRight.data.data[0];

      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          UserId: ` ${item.uid}`,
          WalletAddress: item.wallet,
          MatchingBusiness: item.Req_matching,
          RewardAmount: item.reward,
          Date: ` ${item.date}`,
          PaidDate: ` ${item.tdate}`,
          RankName: ` ${item.rank_name}`,
          PaidHash: ` ${item.txn[0]}`,
        });
      });

      const fileName = "PaidReward";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "uid" },
      { Header: "Wallet Address", accessor: "address" },
      { Header: "Rank Name", accessor: "remark" },
      { Header: "Matching Business", accessor: "amountusd" },
      { Header: "Reward Amount (USDT)", accessor: "requestAmount" },
      { Header: "Requested Date", accessor: "date" },
      { Header: "Paid Date", accessor: "tdate" },
      // { Header: "Contract Paid", accessor: "PaidContract" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Reward History</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={Uid}
                        onChange={(e) => setUid(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter UserId"
                        maxLength={6}
                      />
                    </div>
                    <div class="col-md-2">
                      <select
                        name="Position"
                        className="form-control"
                        onChange={(e) => setRank(e.target.value)}>
                        <option>Select Rank</option>
                        <option value="1">Basic</option>
                        <option value="2">1 STAR</option>
                        <option value="3">2 STAR</option>
                        <option value="4">3 STAR</option>
                        <option value="5">4 STAR</option>
                        <option value="6">5 STAR</option>
                        <option value="7">6 STAR</option>
                        <option value="8">7 STAR</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={uplineId}
                        onChange={(e) => setuplineId(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter UserId"
                        maxLength={6}
                      />
                    </div>

                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setfdate(e.target.value)}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => settdate(e.target.value)}
                        id="tdate"
                        name="tdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Search"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API_Export();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Export To Excel"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <h4>
                      <span></span>
                    </h4>

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RequestTokenPaid;
